<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_service_provider") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.logo')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->
          <!-- Start:: Image Upload Input -->
          <base-multi-image-upload-input
            :urls="imgUrls"
            multiple
            @onFileSelect="onFileSelect"
            @onFileRemove="onFileRemove"
          >
            {{ $t("MESSAGES.Gallery") }}
            {{ $t("PLACEHOLDERS.extendPhoto") }}
            <span class="text-danger">*</span>
          </base-multi-image-upload-input>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Inputs -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.storeTitleAr')"
            v-model.trim="data.nameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.storeTitleEn')"
            v-model.trim="data.nameEn"
            required
          />
          <!-- End:: Name Inputs -->

          <!-- Start:: Description Inputs -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.descProdEn"
            required
          />
          <!-- End:: Description Inputs -->

          <!-- Start:: Store Input -->
          <base-select-input
            col="6"
            :optionsList="sections"
            :placeholder="$t('PLACEHOLDERS.section')"
            v-model="data.section_id"
            @change="showFields"
            required
          />

          <base-select-input
            col="6"
            :optionsList="distinctiveMarks"
            mlutiple
            :placeholder="
              $t('MESSAGES.Distinctive mark of the service provider')
            "
            v-model="data.featured_tag"
          />

          <div class="col-12 mb-3 input_wrapper top_label select_wrapper">
            <GmapAutocomplete
              @place_changed="setPlace"
              @keyup.enter.stop="setPlace"
              :placeholder="$t('MESSAGES.search_place')"
            />
          </div>
          <div class="col-12">
            <gmap-map
              :center="{
                lat: data.lat ?? 24.7136,
                lng: data.lng ?? 46.6753,
              }"
              :zoom="12"
              style="width: 100%; height: 300px"
              @click="setLocation($event, index)"
            >
              <gmap-marker
                v-if="data.lat && data.lng"
                :position="{
                  lat: data.lat,
                  lng: data.lng,
                }"
              />
            </gmap-map>
            <v-btn @click="resetButton" color="primary" class="mt-2">{{
              $t("PLACEHOLDERS.reset_btn")
            }}</v-btn>
          </div>

          <div class="row justify-content-center mt-3">
            <h4>{{ $t("PLACEHOLDERS.contacts") }}</h4>
            <div class="col-l2">
              <div class="add_another" @click="addRow()">
                <i class="fas fa-plus"></i>
              </div>
            </div>
            <div
              class="col-lg-6 col-12"
              v-for="(item, index) in phone_numbers"
              :key="'l' + index"
            >
              <div class="item d-flex align-items-center">
                <base-input
                  class="w-100"
                  type="tel"
                  :placeholder="$t('PLACEHOLDERS.phone')"
                  v-model.trim="item.phone"
                />

                <div class="all_actions">
                  <span class="add_another" @click="removeRow(index)">
                    <i class="fas fa-minus"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
            v-model.trim="data.whatsapp_number"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook')"
            v-model.trim="data.social_media_links.facebook"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.social_media_links.instagram"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.snapchat')"
            v-model.trim="data.social_media_links.snapchat"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.twitter_link')"
            v-model.trim="data.social_media_links.x"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok')"
            v-model.trim="data.social_media_links.tiktok"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.announcement_url')"
            v-model.trim="data.social_media_links.announcement_url"
          />

          \

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseMultiImageUploadInput from "../../../components/formInputs/BaseMultiImageUploadInput.vue";
import BaseNamePreviewFileUploadInput from "../../../components/formInputs/BaseNamePreviewFileUploadInput.vue";
import moment from "moment";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  name: "CreateProviders",

  components: {
    ChangableMapComponent,
    BaseMultiImageUploadInput,
    BaseNamePreviewFileUploadInput,
  },

  data() {
    return {
      isWaitingRequest: false,
      sections: [],
      section_id: null,
      store_waiting: null,
      file: null,
      fileType: "",
      phone_numbers: [
        {
          phone: "",
        },
      ],
      additionalImages: [],
      imgUrls: [],
      data: {
        media: {
          path: null,
          file: null,
        },
        imgUrls: [],
        additionalImages: [],
        whatsapp_number: null,
        nameAr: null,
        social_media_links: {
          facebook: null,
          instagram: null,
          tiktok: null,
          announcement_url: null,
          x: null,
          snapchat: null,
        },
        nameEn: null,
        descProd: null,
        lat: null,
        lng: null,
        descProdEn: null,
        dropdownOptions: {},
        active: true,
        featured_tag: [],
        provider_status: null,
      },
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },
  computed: {
    distinctiveMarks() {
      return [
        {
          id: "new",
          name: this.$t("PLACEHOLDERS.new"),
        },
        {
          id: "trendy",
          name: this.$t("MESSAGES.trendy"),
        },
        {
          id: "most_popular",
          name: this.$t("MESSAGES.most_popular"),
        },
        {
          id: "opened",
          name: this.$t("MESSAGES.opened"),
        },
        {
          id: "soon",
          name: this.$t("MESSAGES.soon"),
        },
        {
          id: "most_visited",
          name: this.$t("MESSAGES.most_visited"),
        },
        {
          id: "available_24_hours",
          name: this.$t("PLACEHOLDERS.available_24_hours"),
        },
        {
          id: "friday_hospitality",
          name: this.$t("PLACEHOLDERS.friday_hospitality"),
        },
      ];
    },
  },
  methods: {
    resetButton() {
      this.data.lat = null;
      this.data.lng = null;
    },
    setLocation(event, index) {
      this.data.lat = event.latLng.lat();
      this.data.lng = event.latLng.lng();
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        this.data.lat = this.currentPlace.geometry.location.lat();
        this.data.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
    addRow() {
      this.phone_numbers.push({ phone: "" });
    },

    removeRow(index) {
      this.phone_numbers.splice(index, 1);
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.data.imgUrls, index);
    },
    onFileSelectField(files) {
      this.data.additionalImages = files;
    },
    onFileRemoveField(index) {
      this.$delete(this.data.imgUrls, index);
    },
    async getSections() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "categories?page=0&limit=0&is_active=1",
        });
        this.sections = res.data.data.data;
        this.store_waiting = "done";
      } catch (error) {
        this.store_waiting = "done";
        console.log(error.response.data.message);
      }
    },

    selectImage(selectedImage) {
      this.data.media = selectedImage;
    },

    showFields(storeId) {
      if (storeId && storeId.fields) {
        this.data.section_id = storeId;
      }
    },

    // async fetchDropdownOptions(fieldId) {
    //   try {
    //     const res = await this.$axios.get(`/dropdown-options/${fieldId}`);
    //     console.log("res", res);
    //     this.dropdownOptions[fieldId] = res.data.options;
    //   } catch (error) {
    //     console.error("Error fetching dropdown options", error);
    //   }
    // },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Basic fields
      REQUEST_DATA.append("name[ar]", this.data.nameAr ?? "");
      REQUEST_DATA.append("name[en]", this.data.nameEn ?? "");
      REQUEST_DATA.append("description[ar]", this.data.descProd ?? "");
      REQUEST_DATA.append("description[en]", this.data.descProdEn ?? "");
      if (this.$route.query?.type) {
        REQUEST_DATA.append("type", this.$route.query.type);
      }

      if (this.data.media.file)
        REQUEST_DATA.append("logo", this.data.media.file);

      // Additional images
      if (this.additionalImages.length > 0) {
        for (let image of this.additionalImages) {
          REQUEST_DATA.append("gallery[]", image);
        }
      }
      if (this.data.section_id?.id)
        REQUEST_DATA.append("category_id", this.data.section_id?.id);
      if (this.data.featured_tag)
        REQUEST_DATA.append("featured_tag", this.data.featured_tag?.id ?? "");

      if (this.data.lat) REQUEST_DATA.append("lat", this.data.lat);
      if (this.data.lng) REQUEST_DATA.append("lng", this.data.lng);
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      if (this.phone_numbers) {
        this.phone_numbers.forEach((element) => {
          REQUEST_DATA.append(`phone_numbers[]`, element.phone);
        });
      }

      REQUEST_DATA.append("whatsapp_number", this.data.whatsapp_number ?? "");
      REQUEST_DATA.append(
        "social_media_links[facebook]",
        this.data.social_media_links.facebook ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[instagram]",
        this.data.social_media_links.instagram ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[tiktok]",
        this.data.social_media_links.tiktok ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[announcement_url]",
        this.data.social_media_links.announcement_url ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[snapchat]",
        this.data.social_media_links.snapchat ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[x]",
        this.data.social_media_links.x ?? ""
      );

      if (this.data.provider_status) {
        REQUEST_DATA.append("provider_status", this.data.provider_status);
      }

      // Send the request with the FormData
      try {
        await this.$axios({
          method: "POST",
          url: "providers",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    this.getSections();
  },
};
</script>
